import { ComponentPropsWithoutRef } from 'react';
import clsx from 'clsx';

/**
 * A layout component for displaying a list of terms and their descriptions.
 */
export function DescriptionList({
  className,
  ...props
}: ComponentPropsWithoutRef<'dl'>) {
  return (
    <dl
      {...props}
      className={clsx(
        className,
        'grid grid-cols-1 text-base/6 sm:grid-cols-[min(50%,--spacing(80))_auto]',
        'sm:text-sm/6'
      )}
    />
  );
}

/**
 * A term or label within a description list.
 */
export function DescriptionTerm({
  className,
  ...props
}: ComponentPropsWithoutRef<'dt'>) {
  return (
    <dt
      {...props}
      className={clsx(
        className,
        'col-start-1 border-t border-gray-950/5 pt-3 text-gray-500',
        'first:border-none sm:border-t sm:border-gray-950/5 sm:py-3',
        'dark:border-white/5 dark:text-gray-400 sm:dark:border-white/5'
      )}
    />
  );
}

/**
 * The details or description for a given term in a description list.
 */
export function DescriptionDetails({
  className,
  ...props
}: ComponentPropsWithoutRef<'dd'>) {
  return (
    <dd
      {...props}
      className={clsx(
        className,
        'pt-1 pb-3 text-gray-950 sm:border-t sm:border-gray-950/5 sm:py-3',
        'sm:nth-2:border-none dark:text-white dark:sm:border-white/5'
      )}
    />
  );
}
